import { supabase } from './supabase';

export type TopicStatKind = 'answer' | 'miss' | 'meta';
export type TopicStatRow = { kind: TopicStatKind; key: string; count: number };

// Fire-and-forget counter increment. Never throws, never blocks gameplay.
export function recordGuessStat(topicId: string, kind: TopicStatKind, key: string) {
  const k = key.slice(0, 60).trim();
  if (!topicId || !k) return;
  void supabase
    .rpc('record_guess', { p_topic_id: topicId, p_kind: kind, p_key: k })
    .then(
      () => {},
      () => {}
    );
}

export async function fetchTopicStats(topicId: string): Promise<TopicStatRow[]> {
  try {
    const { data, error } = await supabase.rpc('get_topic_stats', { p_topic_id: topicId });
    if (error || !data) return [];
    return (data as any[]).map((r) => ({
      kind: r.kind as TopicStatKind,
      key: String(r.key),
      count: Number(r.count) || 0,
    }));
  } catch {
    return [];
  }
}
